export enum CommonRoutes {
   root = "/",
   logout = "/logout",
   login = "/login",
   company = "/company",
   meeting = "/meeting",
 }